/**
 * The source dimensions a transform actually presents to a downstream
 * resize/aspect-fit: rotation by 90/270 swaps width/height, then a crop
 * multiplies each dimension by its fraction. Consumers must compute responsive
 * srcset candidate sizes and the rendered aspect ratio from THIS, not the
 * original asset dimensions, or a cropped image gets the wrong widths/ratio.
 *
 * Mirrors nxt's ContentImage.calculateTransformedSourceDimensions.
 */
export function effectiveSourceDimensions(width, height, transform) {
    let w = width;
    let h = height;
    if (transform === null || transform === void 0 ? void 0 : transform.rotate) {
        const rotatedWidth = transform.rotate % 180 === 0 ? w : h;
        const rotatedHeight = transform.rotate % 180 === 0 ? h : w;
        w = rotatedWidth;
        h = rotatedHeight;
    }
    if ((transform === null || transform === void 0 ? void 0 : transform.crop) && w && h) {
        w = w * transform.crop.width;
        h = h * transform.crop.height;
    }
    // Cropping by a fraction can yield sub-integer dimensions (e.g. 1001 * 0.5 =
    // 500.5); floor to a positive integer so the derived srcset candidate widths and
    // resize filters never carry fractional pixels. A no-op for uncropped sources.
    return {
        width: w === undefined ? undefined : Math.max(1, Math.floor(w)),
        height: h === undefined ? undefined : Math.max(1, Math.floor(h)),
    };
}
